import { Flex, Typography } from '@aloft/toolkit-sui';

import { ValuationTablePropertyHeaderProps } from './types.js';

export const ValuationTablePropertyHeaderThirdLine = ({
  statPrimary,
  statSecondary,
  primaryActionButton,
}: ValuationTablePropertyHeaderProps) => (
  <Flex width="100%" alignItems="center" gap="4px" paddingY={'6px'}>
    <Typography variant="subtitle3">{statPrimary ?? ''}</Typography>
    <Typography variant="subtitle3" color="textTertiary">
      {statSecondary ?? ''}
    </Typography>
    <Flex flexGrow={1} justifyContent="flex-end">
      {primaryActionButton && primaryActionButton}
    </Flex>
  </Flex>
);
